import { AdminMessage } from "@components/admin/admin-helpers"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"
import { FilmSponsorFragment } from "../../types.graphql"

export const meta: BlockMeta = {
  title: "Sponsors",
  description: "Displays the tagged sponsors of this film",
  icon: "groups",
  tags: ["film-sidebar"],
  conditions: {
    postTypes: ["film"],
  },
}

export default defineBlock("film/film-sponsors", (props) => {
  const hasSponsors = !!props.film?.sponsors?.length

  if (!hasSponsors) {
    if (env.admin) {
      return <AdminMessage>No sponsors</AdminMessage>
    }
    return null
  }
  return (
    <div>
      <EditableText store="label" as="div" defaultValue="Sponsored By" className="type-body-xs uppercase mb-3" />
      <div className="flex flex-col gap-3">
        {props.film?.sponsors?.filter(Boolean).map((sponsor, i) => {
          return <FilmSponsor {...sponsor!} key={i} />
        })}
      </div>
    </div>
  )
})

function FilmSponsor(sponsor: FilmSponsorFragment) {
  const logo = sponsor?.info?.logo
  const url = sponsor?.info?.url

  let content = <span className="type-title-xs">{sponsor?.title}</span>
  if (logo && logo.aspect) {
    const scale = logo.aspect > 1 ? lerpMap(logo.aspect, 1, 4, 0.4, 1) : lerpMap(logo.aspect, 1, 0.3, 0.4, 0.2)
    content = (
      <>
        <div className="min-w-[30%] max-w-[50%] md:min-w-1 md:max-w-full" style={{ width: scale * 100 + "%" } as any}>
          <ResponsiveImage {...logo} />
        </div>
      </>
    )
  }

  if (url) {
    content = (
      <Link href={url} target="_blank" className="flex">
        {content}
      </Link>
    )
  }
  return <div>{content}</div>
}

function lerpMap(value: number, inMin: number, inMax: number, outMin: number, outMax: number) {
  return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
}

function lerp(t: number, a: number, b: number) {
  return a + (b - a) * t
}
